module.exports = __webpack_public_path__ + "img/20220219_072802.79670729.jpg";